<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <AppNotify />
  <!-- 全局 loading：API 请求拦截器计数驱动，延迟点亮防闪烁 -->
  <AppLoading />
  <!-- 游戏浮层：点击游戏卡片进入的第三方游戏播放页；Lazy 按需拆 chunk -->
  <LazyGamePlayDrawer />
  <!-- 额度转换：我的四宫格 + 游戏浮层等多入口共用；Lazy 按需拆 chunk -->
  <LazyTransferDrawer />
  <!-- 登录/注册弹窗：顶栏等多入口共用；Lazy 按需拆 chunk -->
  <LazyLoginDrawer />
  <!-- 找回密码弹窗：从登录弹窗"忘记密码?"入口打开，叠加在登录弹窗之上 -->
  <LazyForgotPasswordDrawer />
  <!-- 用户协议：从登录弹窗《用户协议》入口打开，叠在最上层 -->
  <LazyAgreementDrawer />
  <!-- 隐私政策：从登录弹窗《隐私政策》入口打开，叠在最上层 -->
  <LazyPrivacyDrawer />
</template>
